import React from "react";
import { EscalationsAccessList } from "../components/EscalationsAccessList";
import { SettingsManagedPanel } from "../components/SettingsManagedPanel";
import { SettingsLayout } from "../layout/SettingsLayout";

/**
 * EscalationsAccessPage — `/settings/escalations-access`.
 *
 * The last panel of the settings area, and the one with the least to set: the
 * tenant decides who to email from roles alone, so most of this page reports
 * rather than configures.
 */
export const EscalationsAccessPage: React.FC = () => (
  <SettingsLayout>
    <SettingsManagedPanel
      title="Escalations & access"
      description="Who hears about the work, and who can see the books."
    >
      <EscalationsAccessList />
    </SettingsManagedPanel>
  </SettingsLayout>
);
